export default {
  namespaced: true,
  state: {
    expanded: false,
    deleteDialog: {
      show: false,
      title: null,
      description: null,
      itemType: null,
      ids: null,
      action: null,
    },
    isSubNavigationVisible: true,
  },
  mutations: {},
  actions: {
    toggleSubNavigationVisibility({ commit, state, dispatch }) {
      state.isSubNavigationVisible = !state.isSubNavigationVisible;
    },
    toggleExpand({ commit, state, dispatch }) {
      state.expanded = !state.expanded;
    },
    setDeleteDialog({ commit, state, dispatch }, { show, ids = null, title, description, itemType, action }) {
      dispatch("resetActiveContextMenu", null, { root: true });
      const idArray = Array.isArray(ids) ? ids : [ids];
      state.deleteDialog = {
        show,
        ids: idArray,
        title,
        description,
        itemType,
        action,
      };
    },
  },
  getters: {},
};
